import { Typography } from 'lighthouse';

import Reveal from '../Reveal';

import { BatteryCharging, Mobile, TicketDiscount } from 'iconsax-react';

const steps = [
    {
        id: 1,
        icon: <Mobile size={28} color='#008fff' />,
        title: 'شماره موبایلت رو وارد کن',
        description: 'فقط با یک پیامک وارد شو یا ثبت‌نام کن؛ کمتر از یک دقیقه وقتت رو می‌گیره.'
    },
    {
        id: 2,
        icon: <BatteryCharging size={28} color='#008fff' />,
        title: 'باتری به باتری رایگان بگیر',
        description: 'کارشناس ازکی‌سرویس هرجا باشی میاد و ماشینت رو در محل روشن می‌کنه؛ بدون حتی یک تومان هزینه.'
    },
    {
        id: 3,
        icon: <TicketDiscount size={28} color='#008fff' />,
        title: 'باتری جدید رو با تخفیف بخر',
        description: 'کد تخفیفت رو موقع پرداخت وارد کن و باتری اصل با گارانتی معتبر رو ارزان‌تر ببر.'
    }
];

const HowItWorks = () => {
    return (
        <div className='mx-auto mt-16 w-full max-w-6xl px-5'>
            <Reveal>
                <Typography variant='h5' component='h2' fontWeight={800} color='blackHighEmphasis' align='center'>
                    باتری به باتری رایگان فقط در ۳ قدم
                </Typography>
                <Typography variant='body2' component='p' color='blackMediumEmphasis' align='center' className='mt-2'>
                    از روشن شدن ماشینت در محل تا تخفیف خرید باتری جدید
                </Typography>
            </Reveal>

            <div className='mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3'>
                {steps.map((step, index) => (
                    <Reveal key={step.id} delay={index * 120}>
                        <div
                            className='relative flex h-full flex-col items-center rounded-lg bg-white p-6 text-center shadow-elevation1 ring-1
                                ring-black/5 transition-shadow duration-300 hover:shadow-elevation2'>
                            <span
                                className='absolute left-4 top-4 flex h-7 w-7 items-center justify-center rounded-full bg-amber-400 text-sm font-black
                                    text-[#0A1530]'>
                                {step.id}
                            </span>
                            <span className='flex h-14 w-14 items-center justify-center rounded-lg bg-primary/10'>{step.icon}</span>
                            <Typography variant='subtitle1' component='h3' fontWeight={700} color='blackHighEmphasis' className='mt-4'>
                                {step.title}
                            </Typography>
                            <Typography variant='body2' component='p' color='blackMediumEmphasis' className='mt-2 leading-7'>
                                {step.description}
                            </Typography>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    );
};

export default HowItWorks;
